// extracted by extract-css-chunks-webpack-plugin
module.exports = {"authorByline":"_2GdP-7","moreCheckbox":"_3EAPJz","authorBylineFlexContainer":"_1M1rT4"};